module.exports = __webpack_public_path__ + "static/virtual-reality-scooter-67c0d13c69dcc12552830cb8a2bc7350.jpg";